import { createRoot } from "react-dom/client";
import { createElement } from "react";
import { App } from "./Index.js";
import "../../public/style.css";


export const elem = document.getElementById("feliz-app");

export const root = createRoot(elem);

root.render(createElement(App, null));

